import { useEffect, useRef } from 'react'
import { useModal } from '../../../components'
import { ModalSize } from '../../../../_metronic/helpers'
import { useInactivityContext } from './InactivityContext'
import { SessionLockModalContent } from './SessionLockModal'

export const SessionInactivityManager = () => {
  const { showModal, closeModal } = useModal()
  const { status, unlock } = useInactivityContext()

  const modalOpenedByUsRef = useRef(false)

  useEffect(() => {
    if (status === 'bloqueado' && !modalOpenedByUsRef.current) {
      modalOpenedByUsRef.current = true
      showModal({
        title: 'Sessão bloqueada',
        content: <SessionLockModalContent onUnlock={unlock} />,
        size: ModalSize.Medium,
        disableClose: true,
        centered: true,
        darkBackdrop: true,
      })
    } else if (status !== 'bloqueado' && modalOpenedByUsRef.current) {
      modalOpenedByUsRef.current = false
      closeModal()
    }
    // Reexecução por troca de identidade de showModal/closeModal/unlock é no-op: os dois ramos
    // dependem de `status` ter mudado em relação ao ref.
  }, [status, showModal, closeModal, unlock])

  return null
}
